import { c as _c } from "react/compiler-runtime";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslations } from "next-intl";
import { useFormContext, useWatch } from "react-hook-form";
import { AddNewRoomListingSchemaType, MAX_IMAGE_SIZE, MAX_IMAGES } from "../../../api/schema";
export function useNewRoomListingImagesForm() {
  const $ = _c(5);
  const isMobile = useIsMobile();
  const t = useTranslations("modules.listings.addRoomListing.imagesForm");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = Math.round(MAX_IMAGE_SIZE / 1024 / 1024);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const maxImageSizeMB = t0;
  const {
    control
  } = useFormContext();
  const propertyImages = useWatch({
    control,
    name: "associatedPropertyImages"
  }) ?? [];
  let t1;
  if ($[1] !== isMobile || $[2] !== propertyImages || $[3] !== t) {
    t1 = {
      isMobile,
      t,
      maxImageSizeMB,
      MAX_IMAGE_SIZE,
      MAX_IMAGES,
      propertyImages
    };
    $[1] = isMobile;
    $[2] = propertyImages;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}